import React, { FC } from 'react';

import * as Dialog from '@radix-ui/react-dialog';

import { CloseIcon } from '@components/icons';

import styles from './Drawer.module.scss';

export type DrawerProps = {
    title: string;
    isOpen: boolean;
    onOpenChange(isOpen: boolean): void;
};

export const Drawer: FC<DrawerProps> = (props) => {
    const { title, isOpen, onOpenChange, children } = props;

    return (
        <Dialog.Root open={isOpen} onOpenChange={onOpenChange}>
            <Dialog.Portal>
                <Dialog.Overlay className={styles.overlay}>
                    <Dialog.Content className={styles.content}>
                        <div className={styles.header}>
                            <Dialog.Title className={styles.title}>{title}</Dialog.Title>
                            <Dialog.Close className={styles.closeButton}>
                                <CloseIcon className={styles.closeIcon} />
                            </Dialog.Close>
                        </div>

                        {children}
                    </Dialog.Content>
                </Dialog.Overlay>
            </Dialog.Portal>
        </Dialog.Root>
    );
};
